// AI Generated Service
import { Injectable } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { safeClone } from '@client/app/shared/utils/object-utils';

export interface ApiUserScope {
    name: string;
    value: string;
}

@Injectable({
    providedIn: 'root',
})
export class ApiUsersService {
    constructor (private translateService: TranslateService) {}

    getScopes (): ApiUserScope[] {
        const scopes: ApiUserScope[] = [
            {
                name: this.translateService.getString('CMS'),
                value: 'cms',
            },
            {
                name: this.translateService.getString('Customer'),
                value: 'customer',
            },
            {
                name: this.translateService.getString('Admin'),
                value: 'customer_admin',
            },
        ];

        return safeClone(scopes);
    }

    getScopeTranslation (value: string): string | undefined {
        const scopes = this.getScopes();
        const scope = scopes.find(s => s.value === value);
        return scope?.name;
    }
}
